'use es6';

import { useSelector } from 'react-redux';
import { isCrossObject } from 'dashboard-lib/public/report/report-logic';
import { useHideDialog } from 'reporting-action-components/dialog/ducks';
import AsyncSingleReportViewerModal from 'reporting-enablement/components/singleReportViewer/AsyncSingleReportViewerModal';
import { REPORT_TEMPLATE } from 'reporting-enablement/components/singleReportViewer/common/Usage';
import { getUserInfo } from '../../selectors/auth';
import { EVENTS, track, Tracker } from '../../utils/usageTracker';
import useNormalizedReport from '../../utils/useNormalizedReport';
import { jsx as _jsx } from "react/jsx-runtime";
const ReportViewer = props => {
  const {
    report
  } = props;
  const onSaveSuccess = props === null || props === void 0 ? void 0 : props.onSaveSuccess;
  const onClose = useHideDialog();
  const userInfo = useSelector(getUserInfo);
  const getReportTrackingData = action => {
    return {
      isCrossObject: isCrossObject(report),
      template: report.get('templateKey'),
      tags: report.get('contentTags'),
      dataType: report.getIn(['config', 'dataType']),
      location: 'single-report-viewer',
      action
    };
  };
  const normalizedReport = useNormalizedReport({
    report: report.delete('id'),
    onError: err => {
      console.error(err);
    }
  });
  if (!normalizedReport) {
    return null;
  }
  return /*#__PURE__*/_jsx(AsyncSingleReportViewerModal, {
    appUsageTracker: Tracker,
    report: normalizedReport,
    onClose: () => {
      track(EVENTS.clickSaveReport, getReportTrackingData('close'));
      onClose();
    },
    onSaveAsSuccess: response => {
      track(EVENTS.clickSaveReport, getReportTrackingData('save'));
      onSaveSuccess === null || onSaveSuccess === void 0 || onSaveSuccess(response === null || response === void 0 ? void 0 : response.report);
      onClose();
    },
    onSaveClick: () => track(EVENTS.clickSaveReport, getReportTrackingData('create')),
    track: track,
    description: normalizedReport.get('description'),
    use: REPORT_TEMPLATE,
    userInfo: userInfo
  });
};
export default ReportViewer;